import { css } from 'lit';
// typing and self reference gets annoying. maybe have multiple
export const COLOR = {
    action: css `var(--idme-color-action, #F2FAFF)`,
    ash: css `var(--idme-color-ash, #DFDFDF)`,
    august: css `var(--idme-color-august, #0050C7)`,
    black: css `var(--idme-color-black, #000000)`,
    boulder: css `var(--idme-color-boulder, #757575)`,
    citrine: css `var(--idme-color-citrine, #D18100)`,
    danger: css `var(--idme-color-danger, #FFF1F1)`,
    emerald: css `var(--idme-color-emerald, #08833D)`,
    gothic: css `var(--idme-color-gothic, #315B82)`,
    ink: css `var(--idme-color-ink, #172F55)`,
    neon: css `var(--idme-color-neon, #FF9D00)`,
    radon: css `var(--idme-color-radon, #00BE6F)`,
    ruby: css `var(--idme-color-ruby, #BA0000)`,
    sapphire: css `var(--idme-color-sapphire, #1F5DB6)`,
    slate: css `var(--idme-color-slate, #272727)`,
    smoke: css `var(--idme-color-smoke, #F5F5F5)`,
    snow: css `var(--idme-color-snow, #F9F9F9)`,
    stone: css `var(--idme-color-stone, #949494)`,
    success: css `var(--idme-color-success, #EFF8F2)`,
    verifiedGreen: css `var(--idme-color-verified-green, #2EA76D)`,
    warning: css `var(--idme-color-warning, #FFF1F1)`,
    white: css `var(--idme-color-white, #FFFFFF)`,
    xenon: css `var(--idme-color-xenon, #12C4FA)`,
};
export const Z_INDEX = {
    low: css `99`,
    medium: css `999`,
    high: css `9999`,
};
export const TEXT = {
    openSans: css `"Open Sans", Arial, Helvetica, sans-serif`,
    poppins: css `"Poppins", Arial, Helvetica, sans-serif`,
    weight: {
        normal: css `400`,
        medium: css `500`,
        semibold: css `600`,
        bold: css `700`,
    },
    // make these semantic when we have this nailed down
    size: {
        size36: css `font-size: 2.25rem; line-height: 3.375rem;`,
        size24: css `font-size: 1.5rem; line-height: 2.25rem;`,
        size20: css `font-size: 1.25rem; line-height: 1.875rem;`,
        size18: css `font-size: 1.125rem; line-height: 1.5rem;`,
        size16: css `font-size: 1rem; line-height: 1.375rem;`,
        size14: css `font-size: 0.875rem; line-height: 1.1875rem;`,
    },
};
export const TYPOGRAPHY = {
    h3: css `font-family: ${TEXT.poppins}; font-weight: ${TEXT.weight.bold}; ${TEXT.size.size24};`,
    h4: css `font-family: ${TEXT.poppins}; font-weight: ${TEXT.weight.bold}; ${TEXT.size.size20};`,
    body: css `font-family: ${TEXT.openSans}; font-weight: ${TEXT.weight.normal}; ${TEXT.size.size16};`,
    bodySmall: css `font-family: ${TEXT.openSans}; ${TEXT.size.size14}; font-weight: ${TEXT.weight.semibold};`,
    caption: css `font-family: ${TEXT.openSans}; font-weight: ${TEXT.weight.normal}; color: var(--idme-caption-color, ${COLOR.boulder}); ${TEXT.size.size14};`,
    captionCustomColor: (color) => css `font-family: ${TEXT.openSans}; font-weight: ${TEXT.weight.normal}; color: var(${color}, var(--idme-caption-color, ${COLOR.boulder})); ${TEXT.size.size14};`
};
export const UTILITIES = {
    focusOutlineClose: css `outline: 2.5px solid ${COLOR.sapphire}; outline-offset: -1px;`,
    focusOutline: css `outline: 2px solid var(--idme-focus-outline-color, ${COLOR.sapphire}); outline-offset: 2px;`,
    // Overriding --idme-focus-outline-color in the component's style file made it so any outside
    // setting of --idme-focus-outline-color would not take on only the specifically overridden outline
    focusOutlineCustom: (color) => css `outline: 2px solid var(${color}, var(--idme-focus-outline-color, ${COLOR.sapphire})); outline-offset: 2px;`,
    hiddenAccessibleText: css `position: absolute; left: -10000px; top: auto; width: 1px; height: 1px; overflow: hidden;`,
    linkFocusOutline: css `outline: 2px solid var(--idme-focus-outline-color, ${COLOR.sapphire}); outline-offset: 2px; border-radius: 2px;`,
    linkFocusOutlineCustom: (color) => css `outline: 2px solid var(${color}, var(--idme-focus-outline-color, ${COLOR.sapphire})); outline-offset: 2px; border-radius: 2px;`,
    expandClickTarget: css `content: ''; position: absolute; top: 0; bottom: 0; left: 0; right: 0;`,
    featherSVG: css `fill: none; stroke: currentColor; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round;`,
};
export const SHADOWS = {
    container: css `box-shadow: 0 0.375rem 1rem 0 var(--idme-container-shadow-color, rgba(0, 0, 0, 0.16));`,
    containerCustom: (color) => css `box-shadow: 0 0.375rem 1rem 0 var(${color}, var(--idme-container-shadow-color, rgba(0, 0, 0, 0.16)));`,
};
export const MEDIA = {
    size: {
        xs: css `480px`,
        sm: css `768px`,
        md: css `992px`,
        lg: css `1200px`,
        xl: css `1700px`,
    },
};
const STYLES = {
    color: COLOR,
    zIndex: Z_INDEX,
    text: TEXT,
    typography: TYPOGRAPHY,
    utilities: UTILITIES,
    shadows: SHADOWS,
    media: MEDIA,
};
export default STYLES;
//# sourceMappingURL=styles.js.map